import { ValuationRequestPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../constants';

export default (): ValuationRequestPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_VALUATIONREQUEST_POINTER,
  variable: null,
});
